/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Report_Status_ProcessingInputs */

const es_co2_error_report_status_processing = /** @type {(inputs: Error_Report_Status_ProcessingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este reporte ya se está procesando.`)
};

/**

* @param {Error_Report_Status_ProcessingInputs} inputs
* @param {{ locale?: "es-CO" }} options
* @returns {LocalizedString}
*/
export const error_report_status_processing = /** @type {((inputs?: Error_Report_Status_ProcessingInputs, options?: { locale?: "es-CO" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Report_Status_ProcessingInputs, { locale?: "es-CO" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return es_co2_error_report_status_processing(inputs)
});